<template>
  <div class="progress-wrap">
    <div class="progress">
      <div></div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
.progress-wrap {
    text-align: center;
}
.progress {
  position: relative;
  display: inline-block;
  width: 5em;
  height: 5em;
  margin: 0 0.5em;
  font-size: 0.04rem;
  text-indent: 999em;
  overflow: hidden;
  animation: spin 1s infinite steps(8);
}

.small.progress {
  font-size: 6px;
}

.large.progress {
  font-size: 24px;
}

.progress:before,
.progress:after,
.progress > div:before,
.progress > div:after {
  content: "";
  position: absolute;
  top: 0;
  left: 2.25em; /* (container width - part width)/2  */
  width: 0.5em;
  height: 1.5em;
  border-radius: 0.2em;
  background: #eee;
  box-shadow: 0 3.5em rgba(45, 162, 212, 0.2); /* container height - part height */
  transform-origin: 50% 2.5em; /* container height / 2 */
}

.progress:before {
  background: rgba(45, 162, 212, 1);
}

.progress:after {
  transform: rotate(-45deg);
  background: rgba(45, 162, 212, 0.8);
}

.progress > div:before {
  transform: rotate(-90deg);
  background: rgba(45, 162, 212, 0.6);
}

.progress > div:after {
  transform: rotate(-135deg);
  background: rgba(45, 162, 212, 0.4);
}

.progress {
  position: relative;
  top: 8px;
  display: inline-block;
}
</style>